<template>
	<featureSection :feature-name="'dashboard'">
		<main class="reactivate-container">
			<div class="reactivate-card">
				<p class="reactivate-title">{{ isProjectPaused ? t('reactivate.title') : t('reactivate.title_market') }}</p>
				<p class="reactivate-subtitle">{{ t('reactivate.subtitle') }}</p>
				<button class="reactivate-button" :disabled="isReactivating" @click="handleReactivate">
					{{ isReactivating ? t('reactivate.loading') : (isProjectPaused ? t('reactivate.button') : t('reactivate.button_market')) }}
				</button>
			</div>
		</main>
	</featureSection>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import featureSection from '@/components/utilities/featureSection.vue';
import { useMarketStore } from '@/store/global/market';
import { useClientsStore } from '@/store/clients/clients';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const marketStore = useMarketStore();
const { projects, selectedProject, markets, selectedMarket } = storeToRefs(marketStore);

const clientsStore = useClientsStore();

const isReactivating = ref(false);

function getItemById(items, id) {
	return items.find(item => item.id === id) || null;
}

const selectedProjectItem = computed(() => getItemById(projects.value, selectedProject.value));
const selectedMarketItem = computed(() => getItemById(markets.value, selectedMarket.value));
const isProjectPaused = computed(() => selectedProjectItem.value?.type === 'paused');
const isMarketPaused = computed(() => !isProjectPaused.value && selectedMarketItem.value?.type === 'paused');

async function handleReactivate() {
	if (isReactivating.value) {
		return;
	}

	isReactivating.value = true;

	try {
		if (isProjectPaused.value && selectedProjectItem.value) {
			await clientsStore.activateProject(selectedProjectItem.value.id);
		} else if (isMarketPaused.value && selectedMarketItem.value) {
			await clientsStore.activateMarket(selectedMarketItem.value.id);
		}
		await marketStore.fetchData();
	} catch (error) {
		console.error('Failed to reactivate:', error);
	} finally {
		isReactivating.value = false;
	}
}
</script>

<style lang="scss" scoped>
.reactivate-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 60vh;
	padding: 2rem;
}

.reactivate-card {
	max-width: 520px;
	width: 100%;
	border: 1px solid var(--gris-100);
    border-radius: 1rem;
	background-color: var(--blanc);
	padding: 4rem;
	text-align: center;
}

.reactivate-title {
	font-size: 2rem;
	font-weight: 700;
	color: var(--gris-900);
	margin-bottom: 1rem;
}

.reactivate-subtitle {
	font-size: 1.2rem;
	color: var(--gris-700);
	margin-bottom: 1.5rem;
    line-height: 1.2;
}

.reactivate-button {
	border: 1px solid var(--bleu-400);
	background-color: var(--bleu-100);
	color: var(--bleu-700);
    font-size: 1.1rem;
	padding: 0.8rem 1.5rem;
	border-radius: .5rem;
	font-weight: 600;
}
</style>
